
export enum RefundPolicyType{
  INVALID = 0,
  NO_REFUND = 1,
  PRORATE_UNUSED = 2
}

//export type RefundPolicyType = RefundPolicyMap[keyof RefundPolicyMap];